<template class="homeSchool-home">
  <div>
    <header-page />
    <div class="router-top">
      <router-view />
    </div>
  </div>
</template>
<script>
import HeaderPage from '@/pages/common/views/components/headnav/HeadNavHomeSchool';

export default {
  name: 'HomeSchool',
  components: {
    HeaderPage,
  },
  data(){
    return {
    }
  }
};
</script>
<style lang="less" scoped>
.router-top {
  padding-top:90px;
}
</style>
